import React from "react";
import "./timeline.css";

const Timeline = () => {
    return (
        <div className="timeline-wrapper">
            <div className="timeline-line"></div>
            <div className="timeline-item left">
                <div className="timeline-box">
                    <h4>ശ്രീമഹാഗണപതി</h4>
                    <p>
                        ഗണപതിഹോമം, നീരാഞ്ജനം, മഹാഗണപതിഹോമം, അപ്പംമൂടല്‍, മോദകം, മുഴുക്കാപ്പ്, കറുകഹോമം, കറുകമാല, അഷ്ടദ്രവ്യഗണപതിഹോമം
                    </p>
                </div>
            </div>

            <div className="timeline-item right">
                <div className="timeline-box">
                    <h4>രക്ഷസിന്</h4>
                    <p>
                       പത്മമിട്ട പാല്‍പ്പായസം
                    </p>
                </div>
            </div>

            <div className="timeline-item left">
                <div className="timeline-box">
                    <h4>ദേവി</h4>
                    <p>രക്തപുഷ്പാഞ്ജലി, സ്വയംവരാര്‍ച്ചന, കുങ്കുമാര്‍ച്ചന, ഭഗവതിസേവ, അരവണ.</p>
                </div>
            </div>

            <div className="timeline-item right">
                <div className="timeline-box">
                    <h4>ശ്രീ പരമേശ്വരന്‍</h4>
                    <p>
                        ധാര, മൃത്യുന്ജയഹോമം, രുദ്രധാര, കരിക്ക്, എണ്ണ-അഭിഷേകം, വിശേഷാല്‍ അഭിഷേകങ്ങള്‍, മുഴുക്കാപ്പ്, നീരാന്ജനം, പാല്‍പ്പായസം,ശംഖാഭിഷേകം.
                    </p>
                </div>
            </div>

            <div className="timeline-item left">
                <div className="timeline-box">
                    <h4>സുബ്രഹ്മണ്യന്‍</h4>
                    <p>
                        ഷഷ്ടിപൂജ, പഞ്ചാമൃതാഭിഷേകം, വിശേഷാല്‍ അഭിഷേകം, പാനകം, ഭസ്മാഭിഷേകം, താമരവിളക്ക്, സ്വരംവരാര്‍ച്ചന.
                    </p>
                </div>
            </div>

            <div className="timeline-item right">
                <div className="timeline-box">
                    <h4>കരിങ്കാളിയമ്മ</h4>
                    <p>
                        ചൊവ്വ, വെള്ളി, ഞായര്‍ എല്ലാ ദിവസങ്ങളില്‍ ആട്/കോഴി നേര്‍ച്ച പ്രധാനം.
                    </p>
                </div>
            </div>
            <div className="timeline-item left">
                <div className="timeline-box">
                    <h4>ശാസ്താവ്</h4>
                    <p>
                        നെയ്യഭിഷേകം, ശ്രീകോവിലില്‍ നെയ്യ്നിറദീപം, നീരാഞ്ജനം, എള്ള്പായസം, കളഭാഭിഷേകം, പാല്‍പ്പായസം, ഇടിച്ചുപിഴിഞ്ഞപായസം, ഉണ്ണിയപ്പം, അരവണ, പഞ്ചാമൃതാഭിഷേകം, എണ്ണഅഭിഷേകം, അഷ്ടാഭിഷേകം, പാനകം, കരിക്കഭിഷേകം, അര്‍ച്ചനകള്‍, ഉദയാസ്തമയപൂജ, നിത്യപൂജ, സര്‍വ്വാലങ്കാരപൂജ.
                    </p>
                </div>
            </div>
            <div className="timeline-item right">
                <div className="timeline-box">
                    <h4>ഹനുമാന്‍</h4>
                    <p>
                        വെണ്ണ മുഴുക്കാപ്പ്, വടമാല, നീരാഞ്ജനം, അവല്‍നിവേദ്യം, വെറ്റിലമാല ചാര്‍ത്തല്‍, നാരങ്ങ ഹാരം ചാര്‍ത്തല്‍, തൃപ്പാദപൂജ.
                    </p>
                </div>
            </div>
            <div className="timeline-item left">
                <div className="timeline-box">
                    <h4>ആയില്യപൂജ</h4>
                    <p>
                        നൂറുംപാലും, പാലഭിഷേകം, പാല്‍പ്പായസഹോമം, സര്‍പ്പബലി, നാഗരൂട്ട്‌, വിശേഷാല്‍ അഭിഷേകങ്ങള്‍.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Timeline;
